import script from "./StudentCalendarView.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentCalendarView.vue?vue&type=script&setup=true&lang=js"

import "./StudentCalendarView.vue?vue&type=style&index=0&id=1dfb6c3f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dfb6c3f"]])

export default __exports__